/**
 * MPCI Local Dropdown Options - Part 3
 * Monetary, Goods, Weight, Currency fields
 */

// Monetary Amount Type — full 550+ list moved to monetaryAmountTypes.js
export { MONETARY_AMOUNT_TYPE } from './monetaryAmountTypes'

// Charge Category Code
export const CHARGE_CATEGORY = [
  { text: '1 - All charges', value: '1' },
  { text: '2 - Additional charges', value: '2' },
  { text: '3 - Transport charges and additional charges', value: '3' },
  { text: '4 - Basic freight', value: '4' },
  { text: '5 - Destination haulage charges', value: '5' },
  { text: '6 - Disbursement', value: '6' },
  { text: '7 - Destination port charges', value: '7' },
  { text: '8 - Miscellaneous charges', value: '8' },
  { text: '9 - Transport charges up to a specified location', value: '9' },
  { text: '10 - Origin port charges', value: '10' },
  { text: '11 - Origin haulage charges', value: '11' },
  { text: '12 - Other charges', value: '12' },
  { text: '13 - Specific amount payable', value: '13' },
  { text: '14 - Transport costs (carriage charges)', value: '14' },
  { text: '15 - All costs up to a specified location', value: '15' },
  { text: '16 - Weight/valuation charge', value: '16' },
  { text: '17 - All costs', value: '17' },
  { text: '19 - Supply of certificate of shipment', value: '19' },
  { text: '20 - Supply of consular formalities or certificate of origin', value: '20' },
  { text: '21 - Supply of non-categorised documentation in paper form', value: '21' },
  { text: '22 - Supply of customs formalities export', value: '22' },
  { text: '23 - Supply of customs formalities transit', value: '23' },
  { text: '24 - Supply of customs formalities import', value: '24' }
]

// Payment Arrangement Code
export const PAYMENT_ARRANGEMENT = [
  { text: 'A - Payable elsewhere', value: 'A' },
  { text: 'B - Third party to pay', value: 'B' },
  { text: 'C - Collect', value: 'C' },
  { text: 'P - Prepaid', value: 'P' }
]

export const CURRENCY_CODE = [
  { text: 'AED - UAE Dirham', value: 'AED' },
  { text: 'AFN - Afghani', value: 'AFN' },
  { text: 'ALL - Lek', value: 'ALL' },
  { text: 'AMD - Armenian Dram', value: 'AMD' },
  { text: 'AOA - Kwanza', value: 'AOA' },
  { text: 'ARS - Argentine Peso', value: 'ARS' },
  { text: 'AUD - Australian Dollar', value: 'AUD' },
  { text: 'AWG - Aruban Florin', value: 'AWG' },
  { text: 'AZN - Azerbaijan Manat', value: 'AZN' },
  { text: 'BAM - Convertible Mark', value: 'BAM' },
  { text: 'BBD - Barbados Dollar', value: 'BBD' },
  { text: 'BDT - Taka', value: 'BDT' },
  { text: 'BGN - Bulgarian Lev', value: 'BGN' },
  { text: 'BHD - Bahraini Dinar', value: 'BHD' },
  { text: 'BIF - Burundi Franc', value: 'BIF' },
  { text: 'BMD - Bermudian Dollar', value: 'BMD' },
  { text: 'BND - Brunei Dollar', value: 'BND' },
  { text: 'BOB - Boliviano', value: 'BOB' },
  { text: 'BOV - Mvdol', value: 'BOV' },
  { text: 'BRL - Brazilian Real', value: 'BRL' },
  { text: 'BSD - Bahamian Dollar', value: 'BSD' },
  { text: 'BTN - Ngultrum', value: 'BTN' },
  { text: 'BWP - Pula', value: 'BWP' },
  { text: 'BYN - Belarusian Ruble', value: 'BYN' },
  { text: 'BZD - Belize Dollar', value: 'BZD' },
  { text: 'CAD - Canadian Dollar', value: 'CAD' },
  { text: 'CDF - Congolese Franc', value: 'CDF' },
  { text: 'CHE - WIR Euro', value: 'CHE' },
  { text: 'CHF - Swiss Franc', value: 'CHF' },
  { text: 'CHW - WIR Franc', value: 'CHW' },
  { text: 'CLF - Unidad de Fomento', value: 'CLF' },
  { text: 'CLP - Chilean Peso', value: 'CLP' },
  { text: 'CNY - Yuan Renminbi', value: 'CNY' },
  { text: 'COP - Colombian Peso', value: 'COP' },
  { text: 'COU - Unidad de Valor Real', value: 'COU' },
  { text: 'CRC - Costa Rican Colon', value: 'CRC' },
  { text: 'CUP - Cuban Peso', value: 'CUP' },
  { text: 'CVE - Cabo Verde Escudo', value: 'CVE' },
  { text: 'CZK - Czech Koruna', value: 'CZK' },
  { text: 'DJF - Djibouti Franc', value: 'DJF' },
  { text: 'DKK - Danish Krone', value: 'DKK' },
  { text: 'DOP - Dominican Peso', value: 'DOP' },
  { text: 'DZD - Algerian Dinar', value: 'DZD' },
  { text: 'EGP - Egyptian Pound', value: 'EGP' },
  { text: 'ERN - Nakfa', value: 'ERN' },
  { text: 'ETB - Ethiopian Birr', value: 'ETB' },
  { text: 'EUR - Euro', value: 'EUR' },
  { text: 'FJD - Fiji Dollar', value: 'FJD' },
  { text: 'FKP - Falkland Islands Pound', value: 'FKP' },
  { text: 'GBP - Pound Sterling', value: 'GBP' },
  { text: 'GEL - Lari', value: 'GEL' },
  { text: 'GHS - Ghana Cedi', value: 'GHS' },
  { text: 'GIP - Gibraltar Pound', value: 'GIP' },
  { text: 'GMD - Dalasi', value: 'GMD' },
  { text: 'GNF - Guinean Franc', value: 'GNF' },
  { text: 'GTQ - Quetzal', value: 'GTQ' },
  { text: 'GYD - Guyana Dollar', value: 'GYD' },
  { text: 'HKD - Hong Kong Dollar', value: 'HKD' },
  { text: 'HNL - Lempira', value: 'HNL' },
  { text: 'HTG - Gourde', value: 'HTG' },
  { text: 'HUF - Forint', value: 'HUF' },
  { text: 'IDR - Rupiah', value: 'IDR' },
  { text: 'ILS - New Israeli Sheqel', value: 'ILS' },
  { text: 'INR - Indian Rupee', value: 'INR' },
  { text: 'IQD - Iraqi Dinar', value: 'IQD' },
  { text: 'IRR - Iranian Rial', value: 'IRR' },
  { text: 'ISK - Iceland Krona', value: 'ISK' },
  { text: 'JMD - Jamaican Dollar', value: 'JMD' },
  { text: 'JOD - Jordanian Dinar', value: 'JOD' },
  { text: 'JPY - Yen', value: 'JPY' },
  { text: 'KES - Kenyan Shilling', value: 'KES' },
  { text: 'KGS - Som', value: 'KGS' },
  { text: 'KHR - Riel', value: 'KHR' },
  { text: 'KMF - Comorian Franc', value: 'KMF' },
  { text: 'KPW - North Korean Won', value: 'KPW' },
  { text: 'KRW - Won', value: 'KRW' },
  { text: 'KWD - Kuwaiti Dinar', value: 'KWD' },
  { text: 'KYD - Cayman Islands Dollar', value: 'KYD' },
  { text: 'KZT - Tenge', value: 'KZT' },
  { text: 'LAK - Lao Kip', value: 'LAK' },
  { text: 'LBP - Lebanese Pound', value: 'LBP' },
  { text: 'LKR - Sri Lanka Rupee', value: 'LKR' },
  { text: 'LRD - Liberian Dollar', value: 'LRD' },
  { text: 'LSL - Loti', value: 'LSL' },
  { text: 'LYD - Libyan Dinar', value: 'LYD' },
  { text: 'MAD - Moroccan Dirham', value: 'MAD' },
  { text: 'MDL - Moldovan Leu', value: 'MDL' },
  { text: 'MGA - Malagasy Ariary', value: 'MGA' },
  { text: 'MKD - Denar', value: 'MKD' },
  { text: 'MMK - Kyat', value: 'MMK' },
  { text: 'MNT - Tugrik', value: 'MNT' },
  { text: 'MOP - Pataca', value: 'MOP' },
  { text: 'MRU - Ouguiya', value: 'MRU' },
  { text: 'MUR - Mauritius Rupee', value: 'MUR' },
  { text: 'MVR - Rufiyaa', value: 'MVR' },
  { text: 'MWK - Malawi Kwacha', value: 'MWK' },
  { text: 'MXN - Mexican Peso', value: 'MXN' },
  { text: 'MXV - Mexican Unidad de Inversion (UDI)', value: 'MXV' },
  { text: 'MYR - Malaysian Ringgit', value: 'MYR' },
  { text: 'MZN - Mozambique Metical', value: 'MZN' },
  { text: 'NAD - Namibia Dollar', value: 'NAD' },
  { text: 'NGN - Naira', value: 'NGN' },
  { text: 'NIO - Cordoba Oro', value: 'NIO' },
  { text: 'NOK - Norwegian Krone', value: 'NOK' },
  { text: 'NPR - Nepalese Rupee', value: 'NPR' },
  { text: 'NZD - New Zealand Dollar', value: 'NZD' },
  { text: 'OMR - Rial Omani', value: 'OMR' },
  { text: 'PAB - Balboa', value: 'PAB' },
  { text: 'PEN - Sol', value: 'PEN' },
  { text: 'PGK - Kina', value: 'PGK' },
  { text: 'PHP - Philippine Peso', value: 'PHP' },
  { text: 'PKR - Pakistan Rupee', value: 'PKR' },
  { text: 'PLN - Zloty', value: 'PLN' },
  { text: 'PYG - Guarani', value: 'PYG' },
  { text: 'QAR - Qatari Rial', value: 'QAR' },
  { text: 'RON - Romanian Leu', value: 'RON' },
  { text: 'RSD - Serbian Dinar', value: 'RSD' },
  { text: 'RUB - Russian Ruble', value: 'RUB' },
  { text: 'RWF - Rwanda Franc', value: 'RWF' },
  { text: 'SAR - Saudi Riyal', value: 'SAR' },
  { text: 'SBD - Solomon Islands Dollar', value: 'SBD' },
  { text: 'SCR - Seychelles Rupee', value: 'SCR' },
  { text: 'SDG - Sudanese Pound', value: 'SDG' },
  { text: 'SEK - Swedish Krona', value: 'SEK' },
  { text: 'SGD - Singapore Dollar', value: 'SGD' },
  { text: 'SHP - Saint Helena Pound', value: 'SHP' },
  { text: 'SLE - Leone', value: 'SLE' },
  { text: 'SOS - Somali Shilling', value: 'SOS' },
  { text: 'SRD - Surinam Dollar', value: 'SRD' },
  { text: 'SSP - South Sudanese Pound', value: 'SSP' },
  { text: 'STN - Dobra', value: 'STN' },
  { text: 'SVC - El Salvador Colon', value: 'SVC' },
  { text: 'SYP - Syrian Pound', value: 'SYP' },
  { text: 'SZL - Lilangeni', value: 'SZL' },
  { text: 'THB - Baht', value: 'THB' },
  { text: 'TJS - Somoni', value: 'TJS' },
  { text: 'TMT - Turkmenistan New Manat', value: 'TMT' },
  { text: 'TND - Tunisian Dinar', value: 'TND' },
  { text: 'TOP - Pa\'anga', value: 'TOP' },
  { text: 'TRY - Turkish Lira', value: 'TRY' },
  { text: 'TTD - Trinidad and Tobago Dollar', value: 'TTD' },
  { text: 'TWD - New Taiwan Dollar', value: 'TWD' },
  { text: 'TZS - Tanzanian Shilling', value: 'TZS' },
  { text: 'UAH - Hryvnia', value: 'UAH' },
  { text: 'UGX - Uganda Shilling', value: 'UGX' },
  { text: 'USD - US Dollar', value: 'USD' },
  { text: 'USN - US Dollar (Next day)', value: 'USN' },
  { text: 'UYI - Uruguay Peso en Unidades Indexadas (UI)', value: 'UYI' },
  { text: 'UYU - Peso Uruguayo', value: 'UYU' },
  { text: 'UYW - Unidad Previsional', value: 'UYW' },
  { text: 'UZS - Uzbekistan Sum', value: 'UZS' },
  { text: 'VED - Bolivar Soberano', value: 'VED' },
  { text: 'VES - Bolivar Soberano', value: 'VES' },
  { text: 'VND - Dong', value: 'VND' },
  { text: 'VUV - Vatu', value: 'VUV' },
  { text: 'WST - Tala', value: 'WST' },
  { text: 'XAD - Arab Accounting Dinar', value: 'XAD' },
  { text: 'XAF - CFA Franc BEAC', value: 'XAF' },
  { text: 'XAG - Silver', value: 'XAG' },
  { text: 'XAU - Gold', value: 'XAU' },
  { text: 'XBA - Bond Markets Unit European Composite Unit (EURCO)', value: 'XBA' },
  { text: 'XBB - Bond Markets Unit European Monetary Unit (E.M.U.-6)', value: 'XBB' },
  { text: 'XBC - Bond Markets Unit European Unit of Account 9 (E.U.A.-9)', value: 'XBC' },
  { text: 'XBD - Bond Markets Unit European Unit of Account 17 (E.U.A.-17)', value: 'XBD' },
  { text: 'XCD - East Caribbean Dollar', value: 'XCD' },
  { text: 'XCG - Caribbean Guilder', value: 'XCG' },
  { text: 'XDR - SDR (Special Drawing Right)', value: 'XDR' },
  { text: 'XOF - CFA Franc BCEAO', value: 'XOF' },
  { text: 'XPD - Palladium', value: 'XPD' },
  { text: 'XPF - CFP Franc', value: 'XPF' },
  { text: 'XPT - Platinum', value: 'XPT' },
  { text: 'XSU - Sucre', value: 'XSU' },
  { text: 'XTS - Codes reserved for testing purposes', value: 'XTS' },
  { text: 'XUA - ADB Unit of Account', value: 'XUA' },
  { text: 'XXX - No currency involved', value: 'XXX' },
  { text: 'YER - Yemeni Rial', value: 'YER' },
  { text: 'ZAR - Rand', value: 'ZAR' },
  { text: 'ZMW - Zambian Kwacha', value: 'ZMW' },
  { text: 'ZWG - Zimbabwe Gold', value: 'ZWG' }
]

// Weight Unit
export const WEIGHT_UNIT = [
  { text: 'KGM - Kilogram', value: 'KGM' },
  { text: 'GRM - Gram', value: 'GRM' },
  { text: 'TNE - Metric tonne', value: 'TNE' },
  { text: 'LBR - Pound (avoirdupois)', value: 'LBR' },
  { text: 'OZT - Ounce (troy)', value: 'OZT' },
  { text: 'LTX - Long ton (UK)', value: 'LTX' },
  { text: 'SHT - Short ton (US)', value: 'SHT' }
]

// Net Weight Unit (same codes as gross weight per DB)
export const NET_WEIGHT_UNIT = [
  { text: 'KGM - Kilogram', value: 'KGM' },
  { text: 'GRM - Gram', value: 'GRM' },
  { text: 'TNE - Metric tonne', value: 'TNE' },
  { text: 'LBR - Pound', value: 'LBR' },
  { text: 'OZT - Troy ounce', value: 'OZT' },
  { text: 'LTX - Long ton (UK)', value: 'LTX' },
  { text: 'SHT - Short ton (US)', value: 'SHT' }
]

// Volume Unit Code
export const VOLUME_UNIT = [
  { text: 'MTQ - Cubic metre', value: 'MTQ' },
  { text: 'LTR - Litre', value: 'LTR' },
  { text: 'MLT - Millilitre', value: 'MLT' },
  { text: 'DMQ - Cubic decimetre', value: 'DMQ' },
  { text: 'CMQ - Cubic centimetre', value: 'CMQ' },
  { text: 'MMQ - Cubic millimetre', value: 'MMQ' },
  { text: 'HLT - Hectolitre', value: 'HLT' },
  { text: 'A44 - Decalitre', value: 'A44' },
  { text: 'K6 - Kilolitre', value: 'K6' },
  { text: 'INQ - Cubic inch', value: 'INQ' },
  { text: 'FTQ - Cubic foot', value: 'FTQ' },
  { text: 'BLL - Barrel (US)', value: 'BLL' },
  { text: 'BLD - Dry barrel (US)', value: 'BLD' }
]

export const PACKING_DESCRIPTION = [
  { text: '1 - Product ingredients not marked on package', value: '1' },
  { text: '2 - Product price not marked on packaging', value: '2' },
  { text: '3 - Product best before date not marked on product package', value: '3' },
  { text: '4 - Package not marked recyclable', value: '4' },
  { text: '5 - Promotional details marked', value: '5' },
  { text: '6 - Labeled according to general EAN UCC specifications for', value: '6' },
  { text: '7 - Sell by date marked on package', value: '7' },
  { text: '8 - Use by date marked on package', value: '8' },
  { text: '9 - Packaging or manufacturing date marked on package', value: '9' },
  { text: '10 - No freshness date marked on package', value: '10' },
  { text: '31 - Package best before date marked', value: '31' },
  { text: '32 - Package marked recyclable', value: '32' },
  { text: '33 - Package marked returnable', value: '33' },
  { text: '34 - Product marking', value: '34' },
  { text: '35 - Type of package', value: '35' },
  { text: '36 - Package specifications', value: '36' },
  { text: '37 - Package protection', value: '37' },
  { text: '38 - Tarping', value: '38' },
  { text: '39 - Platform or skid location', value: '39' },
  { text: '40 - Bearing piece location', value: '40' },
  { text: '41 - Skid or pallet type', value: '41' },
  { text: '42 - Placement on carrier', value: '42' },
  { text: '43 - Spacing directions', value: '43' },
  { text: '44 - Unloading device', value: '44' },
  { text: '45 - Unloading equipment', value: '45' },
  { text: '46 - Packing method', value: '46' },
  { text: '47 - Packing group I', value: '47' },
  { text: '48 - Packing group II', value: '48' },
  { text: '49 - Packing group III', value: '49' },
  { text: '50 - Package barcoded EAN 13 or EAN 8', value: '50' },
  { text: '51 - Package barcoded ITF 14 or ITF 6', value: '51' },
  { text: '52 - Package barcoded UCC or EAN 128', value: '52' },
  { text: '53 - Package price marked', value: '53' },
  { text: '54 - Product ingredients marked on package', value: '54' },
  { text: '55 - Core characteristics', value: '55' },
  { text: '56 - Shipping requirement', value: '56' },
  { text: '57 - Customs requirement', value: '57' },
  { text: '58 - Transport contract requirement', value: '58' },
  { text: '59 - Preservation method', value: '59' },
  { text: '60 - Product marking pattern', value: '60' },
  { text: '61 - Product marking location', value: '61' },
  { text: '62 - Package or container mark location', value: '62' },
  { text: '63 - Marking method', value: '63' },
  { text: '64 - Package never EPC tagged', value: '64' },
  { text: '65 - Package sometimes EPC tagged', value: '65' },
  { text: '66 - Receiving facility limitations', value: '66' },
  { text: '67 - Tagging or bar code instructions', value: '67' },
  { text: '68 - Shipping package labelling', value: '68' },
  { text: '69 - Shipping package sealing', value: '69' },
  { text: '70 - Optional packaging procedure', value: '70' },
  { text: '71 - Cleaning or drying specification', value: '71' },
  { text: '72 - Cushioning thickness specification', value: '72' },
  { text: '73 - Cushioning and dunnage specification', value: '73' },
  { text: '74 - Level of preservation specification', value: '74' },
  { text: '75 - Preservation material specification', value: '75' },
  { text: '76 - Unit container specification', value: '76' },
  { text: '77 - Material wrapping specification', value: '77' },
  { text: '78 - Package bar-coded and EPC tagged', value: '78' },
  { text: '79 - Package EPC tagged only', value: '79' },
  { text: '80 - Marked with display until date', value: '80' },
  { text: '81 - Package marked with a variable measure barcode', value: '81' },
  { text: '82 - Package marked with fixed measure barcode', value: '82' },
  { text: '83 - RFID not on packaging', value: '83' },
  { text: '84 - RFID on packaging', value: '84' },
  { text: '85 - Package not marked returnable', value: '85' },
  { text: '86 - Gift wrapping', value: '86' },
  { text: '87 - Accompanied by greeting card', value: '87' }
]

export const HANDLING_INSTRUCTION_CODE = [
  { text: '1 - Heat sensitive', value: '1' },
  { text: '2 - Store in dry environment', value: '2' },
  { text: '3 - Stacked', value: '3' },
  { text: '4 - Mooring to be arranged', value: '4' },
  { text: '5 - Mooring arranged', value: '5' },
  { text: '6 - Pilotage to be arranged', value: '6' },
  { text: '7 - Pilotage arranged', value: '7' },
  { text: '8 - Berth towage to be arranged', value: '8' },
  { text: '9 - Disposal of waste to be arranged', value: '9' },
  { text: '10 - Transshipment to be arranged', value: '10' },
  { text: '11 - Refrigeration required', value: '11' },
  { text: '12 - Refrigeration not required', value: '12' },
  { text: '13 - Destroy', value: '13' },
  { text: '14 - Keep frozen', value: '14' },
  { text: '15 - Hang garment', value: '15' },
  { text: '16 - Labelling required', value: '16' },
  { text: '17 - Keep in lying position', value: '17' },
  { text: '18 - Move according to instructions', value: '18' },
  { text: '19 - Pack according to instructions', value: '19' },
  { text: '20 - Prepare for shipment', value: '20' },
  { text: '21 - Reserve according to instructions', value: '21' },
  { text: '22 - Light sensitive', value: '22' },
  { text: '23 - Transit or cross docking delivery required', value: '23' },
  { text: '24 - Unpacking required', value: '24' },
  { text: '25 - Keep in upright or standing position', value: '25' }
]

// Packing Instructions Code (Marking Instructions Type)
export const PACKING_INSTRUCTIONS_CODE = [
  { text: '1 - Do not mark suppliers company name', value: '1' },
  { text: '2 - Mark customers company name', value: '2' },
  { text: '3 - Mark customers references', value: '3' },
  { text: '4 - Mark additionally customers article description', value: '4' },
  { text: '5 - Mark exclusively customers article description', value: '5' },
  { text: '6 - Mark packages dimensions', value: '6' },
  { text: '7 - Mark net weight', value: '7' },
  { text: '8 - Mark gross weight', value: '8' },
  { text: '9 - Mark tare weight', value: '9' },
  { text: '10 - Mark batch number', value: '10' },
  { text: '11 - Mark article number customer', value: '11' },
  { text: '12 - Mark running number of packages', value: '12' },
  { text: '13 - Mark date of production', value: '13' },
  { text: '14 - Mark expiry date', value: '14' },
  { text: '15 - Mark supplier number', value: '15' },
  { text: '16 - Buyers instructions', value: '16' },
  { text: '17 - Sellers instructions', value: '17' },
  { text: '18 - Carriers instructions', value: '18' },
  { text: '19 - Legal requirements', value: '19' },
  { text: '20 - Industry instructions', value: '20' },
  { text: '21 - Line item only', value: '21' },
  { text: '22 - Pre marked by buyer', value: '22' },
  { text: '23 - Entire shipment', value: '23' },
  { text: '24 - Shipper assigned', value: '24' },
  { text: '25 - Shipper assigned roll number', value: '25' },
  { text: '26 - Shipper assigned skid number', value: '26' },
  { text: '27 - Uniform Code Council (UCC) format', value: '27' },
  { text: '28 - Mark free text', value: '28' },
  { text: '29 - Mark case number', value: '29' },
  { text: '30 - Mark serial shipping container code', value: '30' },
  { text: '31 - Marked with ISO 10374 (permanent container tag)', value: '31' },
  { text: '32 - Mark date of packaging', value: '32' },
  { text: '33 - Mark reference to source entity', value: '33' },
  { text: '34 - Marked GS1 Global Individual Asset Identifier', value: '34' },
  { text: '35 - Marked with a product serial number', value: '35' },
  { text: '36 - Marked with a GS1 Global Identification Number for', value: '36' },
  { text: '37 - Marked with a GS1 Global Shipment Identification Number', value: '37' },
  { text: '38 - Marked price', value: '38' },
  { text: '39 - Marked with Serial Shipping Container Code (SSCC)', value: '39' },
  { text: '40 - Marked with first freezing date', value: '40' },
  { text: '41 - Marked with batch number', value: '41' },
  { text: '42 - Marked with production date', value: '42' },
  { text: '43 - Marked with expiry date', value: '43' },
  { text: '44 - Marked with best before date', value: '44' },
  { text: '45 - Marked with net weight', value: '45' },
  { text: '46 - Marked with packaging date', value: '46' },
  { text: '47 - Marked with GS1 Global Returnable Asset Identifier (GRAI)', value: '47' },
  { text: '48 - Marked with a greeting message', value: '48' },
  { text: '49 - Price per unit of measure marked on product', value: '49' },
  { text: 'ZZZ - Mutually defined', value: 'ZZZ' }
]

// Does Package To Be Split
export const SPLIT_PACKAGE = [
  { text: 'Yes', value: 'Yes' },
  { text: 'No', value: 'No' }
]

// Dangerous Goods Hazard Class (full per DB)
export const DG_HAZARD_CLASS = [
  { text: '1 - Explosives', value: '1' },
  { text: '1.1 - Substances and articles which have a mass explosion hazard', value: '1.1' },
  { text: '1.1A - Substances and articles which have a mass explosion hazard, compatibility group A', value: '1.1A' },
  { text: '1.1B - Substances and articles which have a mass explosion hazard, compatibility group B', value: '1.1B' },
  { text: '1.1C - Substances and articles which have a mass explosion hazard, compatibility group C', value: '1.1C' },
  { text: '1.1D - Substances and articles which have a mass explosion hazard, compatibility group D', value: '1.1D' },
  { text: '1.1E - Substances and articles which have a mass explosion hazard, compatibility group E', value: '1.1E' },
  { text: '1.1F - Substances and articles which have a mass explosion hazard, compatibility group F', value: '1.1F' },
  { text: '1.1G - Substances and articles which have a mass explosion hazard, compatibility group G', value: '1.1G' },
  { text: '1.1J - Substances and articles which have a mass explosion hazard, compatibility group J', value: '1.1J' },
  { text: '1.1L - Substances and articles which have a mass explosion hazard, compatibility group L', value: '1.1L' },
  { text: '1.2 - Substances and articles which have a projection hazard but not a mass explosion hazard', value: '1.2' },
  { text: '1.2B - Substances and articles which have a projection hazard but not a mass explosion hazard, compatibility group B', value: '1.2B' },
  { text: '1.2C - Substances and articles which have a projection hazard but not a mass explosion hazard, compatibility group C', value: '1.2C' },
  { text: '1.2D - Substances and articles which have a projection hazard but not a mass explosion hazard, compatibility group D', value: '1.2D' },
  { text: '1.2E - Substances and articles which have a projection hazard but not a mass explosion hazard, compatibility group E', value: '1.2E' },
  { text: '1.2F - Substances and articles which have a projection hazard but not a mass explosion hazard, compatibility group F', value: '1.2F' },
  { text: '1.2G - Substances and articles which have a projection hazard but not a mass explosion hazard, compatibility group G', value: '1.2G' },
  { text: '1.2H - Substances and articles which have a projection hazard but not a mass explosion hazard, compatibility group H', value: '1.2H' },
  { text: '1.2J - Substances and articles which have a projection hazard but not a mass explosion hazard, compatibility group J', value: '1.2J' },
  { text: '1.2K - Substances and articles which have a projection hazard but not a mass explosion hazard, compatibility group K', value: '1.2K' },
  { text: '1.2L - Substances and articles which have a projection hazard but not a mass explosion hazard, compatibility group L', value: '1.2L' },
  { text: '1.3 - Substances and articles which have a fire hazard and either a minor blast hazard or a minor projection hazard, or both, but not a mass explosion hazard', value: '1.3' },
  { text: '1.3C - Substances and articles which have a fire hazard and either a minor blast hazard or a minor projection hazard, or both, but not a mass explosion hazard, category C', value: '1.3C' },
  { text: '1.3F - Substances and articles which have a fire hazard and either a minor blast hazard or a minor projection hazard, or both, but not a mass explosion hazard, category F', value: '1.3F' },
  { text: '1.3G - Substances and articles which have a fire hazard and either a minor blast hazard or a minor projection hazard, or both, but not a mass explosion hazard, category G', value: '1.3G' },
  { text: '1.3H - Substances and articles which have a fire hazard and either a minor blast hazard or a minor projection hazard, or both, but not a mass explosion hazard, category H', value: '1.3H' },
  { text: '1.3J - Substances and articles which have a fire hazard and either a minor blast hazard or a minor projection hazard, or both, but not a mass explosion hazard, category J', value: '1.3J' },
  { text: '1.3K - Substances and articles which have a fire hazard and either a minor blast hazard or a minor projection hazard, or both, but not a mass explosion hazard, category K', value: '1.3K' },
  { text: '1.3L - Substances and articles which have a fire hazard and either a minor blast hazard or a minor projection hazard, or both, but not a mass explosion hazard, category L', value: '1.3L' },
  { text: '1.4 - Substances and articles which present no significant hazard', value: '1.4' },
  { text: '1.4B - Substances and articles which present no significant hazard, compatibility group B', value: '1.4B' },
  { text: '1.4C - Substances and articles which present no significant hazard, compatibility group C', value: '1.4C' },
  { text: '1.4D - Substances and articles which present no significant hazard, compatibility group D', value: '1.4D' },
  { text: '1.4E - Substances and articles which present no significant hazard, compatibility group E', value: '1.4E' },
  { text: '1.4F - Substances and articles which present no significant hazard, compatibility group F', value: '1.4F' },
  { text: '1.4G - Substances and articles which present no significant hazard, compatibility group G', value: '1.4G' },
  { text: '1.4S - Substances and articles which present no significant hazard, compatibility group S', value: '1.4S' },
  { text: '1.5 - Very insensitive substances which have a mass explosion hazard', value: '1.5' },
  { text: '1.5D - Very insensitive substances which have a mass explosion hazard, compatibility group D', value: '1.5D' },
  { text: '1.6 - Extremely insensitive articles which do not have a mass explosion hazard', value: '1.6' },
  { text: '1.6N - Extremely insensitive articles which do not have a mass explosion hazard compatibility group N', value: '1.6N' },
  { text: '2 - Gases', value: '2' },
  { text: '2.1 - Flammable gases', value: '2.1' },
  { text: '2.2 - Non-flammable, non-toxic gases', value: '2.2' },
  { text: '2.3 - Toxic gases', value: '2.3' },
  { text: '3 - Flammable liquids', value: '3' },
  { text: '4 - Flammable solids; substances liable to spontaneous combustion; substances which, in contact with water, emit flammable gases', value: '4' },
  { text: '4.1 - Flammable solids, self-reactive substances and desensitized explosives', value: '4.1' },
  { text: '4.2 - Substances liable to spontaneous combustion', value: '4.2' },
  { text: '4.3 - Substances which, in contact with water, emit flammable gases', value: '4.3' },
  { text: '5 - Oxidizing substances and organic peroxides', value: '5' },
  { text: '5.1 - Oxidizing substances', value: '5.1' },
  { text: '5.2 - Organic peroxides', value: '5.2' },
  { text: '6 - Toxic and infectious substances', value: '6' },
  { text: '6.1 - Toxic substances', value: '6.1' },
  { text: '6.2 - Infectious substances', value: '6.2' },
  { text: '7 - Radioactive material', value: '7' },
  { text: '8 - Corrosive substances', value: '8' },
  { text: '9 - Miscellaneous dangerous substances and articles', value: '9' },
  { text: 'P - Marine pollutant', value: 'P' }
]

// DG Packaging Danger Level
export const DG_PACKAGING_DANGER_LEVEL = [
  { text: '1 - Great danger', value: '1' },
  { text: '2 - Medium danger', value: '2' },
  { text: '3 - Minor danger', value: '3' },
  { text: '4 - Not assigned', value: '4' }
]

// Package Type
export const PACKAGE_TYPE = [
  { text: '1A - Drum, steel', value: '1A' },
  { text: '1B - Drum, aluminium', value: '1B' },
  { text: '1D - Drum, plywood', value: '1D' },
  { text: '1F - Container, flexible', value: '1F' },
  { text: '1G - Drum, fibre', value: '1G' },
  { text: '1W - Drum, wooden', value: '1W' },
  { text: '2C - Barrel, wooden', value: '2C' },
  { text: '3A - Jerrican, steel', value: '3A' },
  { text: '3H - Jerrican, plastic', value: '3H' },
  { text: '43 - Bag, super bulk', value: '43' },
  { text: '44 - Bag, polybag', value: '44' },
  { text: '4A - Box, steel', value: '4A' },
  { text: '4B - Box, aluminium', value: '4B' },
  { text: '4C - Box, natural wood', value: '4C' },
  { text: '4D - Box, plywood', value: '4D' },
  { text: '4F - Box, reconstituted wood', value: '4F' },
  { text: '4G - Box, fibreboard', value: '4G' },
  { text: '4H - Box, plastic', value: '4H' },
  { text: '5H - Bag, woven plastic', value: '5H' },
  { text: '5L - Bag, textile', value: '5L' },
  { text: '5M - Bag, paper', value: '5M' },
  { text: '6H - Composite packaging, plastic receptacle', value: '6H' },
  { text: '6P - Composite packaging, glass receptacle', value: '6P' },
  { text: '7A - Case, car', value: '7A' },
  { text: '7B - Case, wooden', value: '7B' },
  { text: '8A - Pallet, wooden', value: '8A' },
  { text: '8B - Crate, wooden', value: '8B' },
  { text: '8C - Bundle, wooden', value: '8C' },
  { text: 'AA - Intermediate bulk container, rigid plastic', value: 'AA' },
  { text: 'AB - Receptacle, fibre', value: 'AB' },
  { text: 'AC - Receptacle, paper', value: 'AC' },
  { text: 'AD - Receptacle, wooden', value: 'AD' },
  { text: 'AE - Aerosol', value: 'AE' },
  { text: 'AF - Pallet, modular, collars 80cms * 60cms', value: 'AF' },
  { text: 'AG - Pallet, shrinkwrapped', value: 'AG' },
  { text: 'AH - Pallet, 100cms * 110cms', value: 'AH' },
  { text: 'AI - Clamshell', value: 'AI' },
  { text: 'AJ - Cone', value: 'AJ' },
  { text: 'AL - Ball', value: 'AL' },
  { text: 'AM - Ampoule, non-protected', value: 'AM' },
  { text: 'AP - Ampoule, protected', value: 'AP' },
  { text: 'AT - Atomizer', value: 'AT' },
  { text: 'AV - Capsule', value: 'AV' },
  { text: 'B4 - Belt', value: 'B4' },
  { text: 'BA - Barrel', value: 'BA' },
  { text: 'BB - Bobbin', value: 'BB' },
  { text: 'BC - Bottlecrate / bottlerack', value: 'BC' },
  { text: 'BD - Board', value: 'BD' },
  { text: 'BE - Bundle', value: 'BE' },
  { text: 'BF - Balloon, non-protected', value: 'BF' },
  { text: 'BG - Bag', value: 'BG' },
  { text: 'BH - Bunch', value: 'BH' },
  { text: 'BI - Bin', value: 'BI' },
  { text: 'BJ - Bucket', value: 'BJ' },
  { text: 'BK - Basket', value: 'BK' },
  { text: 'BL - Bale, compressed', value: 'BL' },
  { text: 'BM - Basin', value: 'BM' },
  { text: 'BN - Bale, non-compressed', value: 'BN' },
  { text: 'BO - Bottle, non-protected, cylindrical', value: 'BO' },
  { text: 'BP - Balloon, protected', value: 'BP' },
  { text: 'BQ - Bottle, protected cylindrical', value: 'BQ' },
  { text: 'BR - Bar', value: 'BR' },
  { text: 'BS - Bottle, non-protected, bulbous', value: 'BS' },
  { text: 'BT - Bolt', value: 'BT' },
  { text: 'BU - Butt', value: 'BU' },
  { text: 'BV - Bottle, protected bulbous', value: 'BV' },
  { text: 'BW - Box, for liquids', value: 'BW' },
  { text: 'BX - Box', value: 'BX' },
  { text: 'BY - Board, in bundle/bunch/truss', value: 'BY' },
  { text: 'BZ - Bars, in bundle/bunch/truss', value: 'BZ' },
  { text: 'CA - Can, rectangular', value: 'CA' },
  { text: 'CB - Crate, beer', value: 'CB' },
  { text: 'CC - Churn', value: 'CC' },
  { text: 'CD - Can, with handle and spout', value: 'CD' },
  { text: 'CE - Creel', value: 'CE' },
  { text: 'CF - Coffer', value: 'CF' },
  { text: 'CG - Cage', value: 'CG' },
  { text: 'CH - Chest', value: 'CH' },
  { text: 'CI - Canister', value: 'CI' },
  { text: 'CJ - Coffin', value: 'CJ' },
  { text: 'CK - Cask', value: 'CK' },
  { text: 'CL - Coil', value: 'CL' },
  { text: 'CM - Card', value: 'CM' },
  { text: 'CN - Container, not otherwise specified as transport equipment', value: 'CN' },
  { text: 'CO - Carboy, non-protected', value: 'CO' },
  { text: 'CP - Carboy, protected', value: 'CP' },
  { text: 'CQ - Cartridge', value: 'CQ' },
  { text: 'CR - Crate', value: 'CR' },
  { text: 'CS - Case', value: 'CS' },
  { text: 'CT - Carton', value: 'CT' },
  { text: 'CU - Cup', value: 'CU' },
  { text: 'CV - Cover', value: 'CV' },
  { text: 'CW - Cage, roll', value: 'CW' },
  { text: 'CX - Can, cylindrical', value: 'CX' },
  { text: 'CY - Cylinder', value: 'CY' },
  { text: 'CZ - Canvas', value: 'CZ' },
  { text: 'DA - Crate, multiple layer, plastic', value: 'DA' },
  { text: 'DB - Crate, multiple layer, wooden', value: 'DB' },
  { text: 'DC - Crate, multiple layer, cardboard', value: 'DC' },
  { text: 'DG - Cage, Commonwealth Handling Equipment Pool (CHEP)', value: 'DG' },
  { text: 'DH - Box, Commonwealth Handling Equipment Pool (CHEP), Eurobox', value: 'DH' },
  { text: 'DI - Drum, iron', value: 'DI' },
  { text: 'DJ - Demijohn, non-protected', value: 'DJ' },
  { text: 'DK - Crate, bulk, cardboard', value: 'DK' },
  { text: 'DL - Crate, bulk, plastic', value: 'DL' },
  { text: 'DM - Crate, bulk, wooden', value: 'DM' },
  { text: 'DN - Dispenser', value: 'DN' },
  { text: 'DP - Demijohn, protected', value: 'DP' },
  { text: 'DR - Drum', value: 'DR' },
  { text: 'DS - Tray, one layer no cover, plastic', value: 'DS' },
  { text: 'DT - Tray, one layer no cover, wooden', value: 'DT' },
  { text: 'DU - Tray, one layer no cover, polystyrene', value: 'DU' },
  { text: 'DV - Tray, one layer no cover, cardboard', value: 'DV' },
  { text: 'DW - Tray, two layers no cover, plastic tray', value: 'DW' },
  { text: 'DX - Tray, two layers no cover, wooden', value: 'DX' },
  { text: 'DY - Tray, two layers no cover, cardboard', value: 'DY' },
  { text: 'EC - Bag, plastic', value: 'EC' },
  { text: 'ED - Case, with pallet base', value: 'ED' },
  { text: 'EE - Case, with pallet base, wooden', value: 'EE' },
  { text: 'EF - Case, with pallet base, cardboard', value: 'EF' },
  { text: 'EG - Case, with pallet base, plastic', value: 'EG' },
  { text: 'EH - Case, with pallet base, metal', value: 'EH' },
  { text: 'EI - Case, isothermic', value: 'EI' },
  { text: 'EN - Envelope', value: 'EN' },
  { text: 'FB - Flexibag', value: 'FB' },
  { text: 'FC - Crate, fruit', value: 'FC' },
  { text: 'FD - Crate, framed', value: 'FD' },
  { text: 'FE - Flexitank', value: 'FE' },
  { text: 'FI - Firkin', value: 'FI' },
  { text: 'FL - Flask', value: 'FL' },
  { text: 'FO - Footlocker', value: 'FO' },
  { text: 'FP - Filmpack', value: 'FP' },
  { text: 'FR - Frame', value: 'FR' },
  { text: 'FT - Foodtainer', value: 'FT' },
  { text: 'FW - Cart, flatbed', value: 'FW' },
  { text: 'FX - Bag, flexible container', value: 'FX' },
  { text: 'GB - Bottle, gas', value: 'GB' },
  { text: 'GI - Girder', value: 'GI' },
  { text: 'GL - Container, gallon', value: 'GL' },
  { text: 'GR - Receptacle, glass', value: 'GR' },
  { text: 'GU - Tray, containing horizontally stacked flat items', value: 'GU' },
  { text: 'GY - Bag, gunny', value: 'GY' },
  { text: 'GZ - Girders, in bundle/bunch/truss', value: 'GZ' },
  { text: 'HA - Basket, with handle, plastic', value: 'HA' },
  { text: 'HB - Basket, with handle, wooden', value: 'HB' },
  { text: 'HC - Basket, with handle, cardboard', value: 'HC' },
  { text: 'HG - Hogshead', value: 'HG' },
  { text: 'HN - Hanger', value: 'HN' },
  { text: 'HR - Hamper', value: 'HR' },
  { text: 'IA - Package, display, wooden', value: 'IA' },
  { text: 'IB - Package, display, cardboard', value: 'IB' },
  { text: 'IC - Package, display, plastic', value: 'IC' },
  { text: 'ID - Package, display, metal', value: 'ID' },
  { text: 'IE - Package, show', value: 'IE' },
  { text: 'IF - Package, flow', value: 'IF' },
  { text: 'IG - Package, paper wrapped', value: 'IG' },
  { text: 'IH - Drum, plastic', value: 'IH' },
  { text: 'IK - Package, cardboard, with bottle grip-holes', value: 'IK' },
  { text: 'IL - Tray, rigid, lidded stackable (CEN TS 14482:2002)', value: 'IL' },
  { text: 'IN - Ingot', value: 'IN' },
  { text: 'IZ - Ingots, in bundle/bunch/truss', value: 'IZ' },
  { text: 'JB - Bag, jumbo', value: 'JB' },
  { text: 'JC - Jerrican, rectangular', value: 'JC' },
  { text: 'JG - Jug', value: 'JG' },
  { text: 'JR - Jar', value: 'JR' },
  { text: 'JT - Jutebag', value: 'JT' },
  { text: 'JY - Jerrican, cylindrical', value: 'JY' },
  { text: 'KG - Keg', value: 'KG' },
  { text: 'KI - Kit', value: 'KI' },
  { text: 'LE - Luggage', value: 'LE' },
  { text: 'LG - Log', value: 'LG' },
  { text: 'LT - Lot', value: 'LT' },
  { text: 'LU - Lug', value: 'LU' },
  { text: 'LV - Liftvan', value: 'LV' },
  { text: 'LZ - Logs, in bundle/bunch/truss', value: 'LZ' },
  { text: 'MA - Crate, metal', value: 'MA' },
  { text: 'MB - Bag, multiply', value: 'MB' },
  { text: 'MC - Crate, milk', value: 'MC' },
  { text: 'ME - Container, metal', value: 'ME' },
  { text: 'MR - Receptacle, metal', value: 'MR' },
  { text: 'MS - Sack, multi-wall', value: 'MS' },
  { text: 'MT - Mat', value: 'MT' },
  { text: 'MW - Receptacle, plastic wrapped', value: 'MW' },
  { text: 'MX - Matchbox', value: 'MX' },
  { text: 'NA - Not available', value: 'NA' },
  { text: 'NE - Unpacked or unpackaged', value: 'NE' },
  { text: 'NF - Unpacked or unpackaged, single unit', value: 'NF' },
  { text: 'NG - Unpacked or unpackaged, multiple units', value: 'NG' },
  { text: 'NS - Nest', value: 'NS' },
  { text: 'NT - Net', value: 'NT' },
  { text: 'NU - Net, tube, plastic', value: 'NU' },
  { text: 'NV - Net, tube, textile', value: 'NV' },
  { text: 'OA - Pallet, CHEP 40 cm x 60 cm', value: 'OA' },
  { text: 'OB - Pallet, CHEP 80 cm x 120 cm', value: 'OB' },
  { text: 'OC - Pallet, CHEP 100 cm x 120 cm', value: 'OC' },
  { text: 'OD - Pallet, AS 4068-1993', value: 'OD' },
  { text: 'OE - Pallet, ISO T11', value: 'OE' },
  { text: 'OF - Platform, unspecified weight or dimension', value: 'OF' },
  { text: 'OK - Block', value: 'OK' },
  { text: 'OT - Octabin', value: 'OT' },
  { text: 'OU - Container, outer', value: 'OU' },
  { text: 'OG - Pallet ISO 0', value: 'OG' },
  { text: 'OH - Pallet ISO 1', value: 'OH' },
  { text: 'OI - Pallet ISO 2 – 2/1 EURO Pallet', value: 'OI' },
  { text: 'OJ - 1/4 EURO Pallet', value: 'OJ' },
  { text: 'OL - 1/8 EURO Pallet', value: 'OL' },
  { text: 'OM - Synthetic pallet ISO 1', value: 'OM' },
  { text: 'ON - Synthetic pallet ISO 2', value: 'ON' },
  { text: 'OP - Wholesaler pallet', value: 'OP' },
  { text: 'OQ - Pallet 80 X 100 cm', value: 'OQ' },
  { text: 'OR - Pallet 60 X 100 cm', value: 'OR' },
  { text: 'OS - Oneway pallet', value: 'OS' },
  { text: 'OV - Returnable pallet', value: 'OV' },
  { text: 'OW - Large bag, pallet sized', value: 'OW' },
  { text: 'OX - A wheeled pallet with raised rim (81 x 67 x 135)', value: 'OX' },
  { text: 'OY - A Wheeled pallet with raised rim (81 x 72 x 135)', value: 'OY' },
  { text: 'OZ - Wheeled pallet with raised rim ( 81 x 60 x 16)', value: 'OZ' },
  { text: 'O1 - Two sided cage on wheels with fixing strap', value: 'O1' },
  { text: 'O2 - Trolley', value: 'O2' },
  { text: 'O3 - Oneway pallet ISO 0', value: 'O3' },
  { text: 'O4 - Oneway pallet ISO 1', value: 'O4' },
  { text: 'O5 - Oneway pallet ISO 2', value: 'O5' },
  { text: 'O6 - Pallet with exceptional dimensions', value: 'O6' },
  { text: 'O7 - Wooden pallet 40 cm x 80 cm', value: 'O7' },
  { text: 'O8 - Plastic pallet SRS 60 cm x 80 cm', value: 'O8' },
  { text: 'O9 - Plastic pallet SRS 80 cm x 120 cm', value: 'O9' },
  { text: 'P1 - CHEP pallet 60 cm x 80 cm', value: 'P1' },
  { text: 'P3 - LPR pallet 60 cm x 80 cm', value: 'P3' },
  { text: 'P4 - LPR pallet 80 cm x 120 cm', value: 'P4' },
  { text: 'P2 - Pan', value: 'P2' },
  { text: 'PA - Packet', value: 'PA' },
  { text: 'PB - Pallet, box Combined open-ended box and pallet', value: 'PB' },
  { text: 'PC - Parcel', value: 'PC' },
  { text: 'PD - Pallet, modular, collars 80cms * 100cms', value: 'PD' },
  { text: 'PE - Pallet, modular, collars 80cms * 120cms', value: 'PE' },
  { text: 'PF - Pen', value: 'PF' },
  { text: 'PG - Plate', value: 'PG' },
  { text: 'PH - Pitcher', value: 'PH' },
  { text: 'PI - Pipe', value: 'PI' },
  { text: 'PJ - Punnet', value: 'PJ' },
  { text: 'PK - Package', value: 'PK' },
  { text: 'PL - Pail', value: 'PL' },
  { text: 'PN - Plank', value: 'PN' },
  { text: 'PO - Pouch', value: 'PO' },
  { text: 'PP - Piece', value: 'PP' },
  { text: 'PR - Receptacle, plastic', value: 'PR' },
  { text: 'PT - Pot', value: 'PT' },
  { text: 'PU - Tray', value: 'PU' },
  { text: 'PV - Pipes, in bundle/bunch/truss', value: 'PV' },
  { text: 'PX - Pallet', value: 'PX' },
  { text: 'PY - Plates, in bundle/bunch/truss', value: 'PY' },
  { text: 'PZ - Planks, in bundle/bunch/truss', value: 'PZ' },
  { text: 'QA - Drum, steel, non-removable head', value: 'QA' },
  { text: 'QB - Drum, steel, removable head', value: 'QB' },
  { text: 'QC - Drum, aluminium, non-removable head', value: 'QC' },
  { text: 'QD - Drum, aluminium, removable head', value: 'QD' },
  { text: 'QF - Drum, plastic, non-removable head', value: 'QF' },
  { text: 'QG - Drum, plastic, removable head', value: 'QG' },
  { text: 'QH - Barrel, wooden, bung type', value: 'QH' },
  { text: 'QJ - Barrel, wooden, removable head', value: 'QJ' },
  { text: 'QK - Jerrican, steel, non-removable head', value: 'QK' },
  { text: 'QL - Jerrican, steel, removable head', value: 'QL' },
  { text: 'QM - Jerrican, plastic, non-removable head', value: 'QM' },
  { text: 'QN - Jerrican, plastic, removable head', value: 'QN' },
  { text: 'QP - Box, wooden, natural wood, ordinary', value: 'QP' },
  { text: 'QQ - Box, wooden, natural wood, with sift proof walls', value: 'QQ' },
  { text: 'QR - Box, plastic, expanded', value: 'QR' },
  { text: 'QS - Box, plastic, solid', value: 'QS' },
  { text: 'RD - Rod', value: 'RD' },
  { text: 'RG - Ring', value: 'RG' },
  { text: 'RJ - Rack, clothing hanger', value: 'RJ' },
  { text: 'RK - Rack', value: 'RK' },
  { text: 'RL - Reel', value: 'RL' },
  { text: 'RO - Roll', value: 'RO' },
  { text: 'RT - Rednet', value: 'RT' },
  { text: 'RZ - Rods, in bundle/bunch/truss', value: 'RZ' },
  { text: 'SA - Sack', value: 'SA' },
  { text: 'SB - Slab', value: 'SB' },
  { text: 'SC - Crate, shallow', value: 'SC' },
  { text: 'SD - Spindle', value: 'SD' },
  { text: 'SE - Sea-chest', value: 'SE' },
  { text: 'SH - Sachet', value: 'SH' },
  { text: 'SI - Skid', value: 'SI' },
  { text: 'SK - Case, skeleton', value: 'SK' },
  { text: 'SL - Slipsheet', value: 'SL' },
  { text: 'SM - Sheetmetal', value: 'SM' },
  { text: 'SO - Spool', value: 'SO' },
  { text: 'SP - Sheet, plastic wrapping', value: 'SP' },
  { text: 'SS - Case, steel', value: 'SS' },
  { text: 'ST - Sheet', value: 'ST' },
  { text: 'SU - Suitcase', value: 'SU' },
  { text: 'SV - Envelope, steel', value: 'SV' },
  { text: 'SW - Shrinkwrapped', value: 'SW' },
  { text: 'SX - Set', value: 'SX' },
  { text: 'SY - Sleeve', value: 'SY' },
  { text: 'SZ - Sheets, in bundle/bunch/truss', value: 'SZ' },
  { text: 'T1 - Tablet', value: 'T1' },
  { text: 'TB - Tub', value: 'TB' },
  { text: 'TC - Tea-chest', value: 'TC' },
  { text: 'TD - Tube, collapsible', value: 'TD' },
  { text: 'TE - Tyre', value: 'TE' },
  { text: 'TG - Tank container, generic', value: 'TG' },
  { text: 'TI - Tierce', value: 'TI' },
  { text: 'TK - Tank, rectangular', value: 'TK' },
  { text: 'TL - Tub, with lid', value: 'TL' },
  { text: 'TN - Tin', value: 'TN' },
  { text: 'TO - Tun', value: 'TO' },
  { text: 'TR - Trunk', value: 'TR' },
  { text: 'TS - Truss', value: 'TS' },
  { text: 'TT - Bag, tote', value: 'TT' },
  { text: 'TU - Tube', value: 'TU' },
  { text: 'TV - Tube, with nozzle', value: 'TV' },
  { text: 'TW - Pallet, triwall', value: 'TW' },
  { text: 'TY - Tank, cylindrical', value: 'TY' },
  { text: 'TZ - Tubes, in bundle/bunch/truss', value: 'TZ' },
  { text: 'UC - Uncaged', value: 'UC' },
  { text: 'UN - Unit', value: 'UN' },
  { text: 'VA - Vat', value: 'VA' },
  { text: 'VG - Bulk, gas (at 1031 mbar and 15°C)', value: 'VG' },
  { text: 'VI - Vial', value: 'VI' },
  { text: 'VK - Vanpack', value: 'VK' },
  { text: 'VL - Bulk, liquid', value: 'VL' },
  { text: 'VO - Bulk, solid, large particles ((nodules))', value: 'VO' },
  { text: 'VP - Vacuum', value: 'VP' },
  { text: 'VQ - Bulk, liquefied gas (at abnormal temperature/pressure)', value: 'VQ' },
  { text: 'VN - Vehicle', value: 'VN' },
  { text: 'VR - Bulk, solid, granular particles ((grains))', value: 'VR' },
  { text: 'VS - Bulk, scrap metal', value: 'VS' },
  { text: 'VY - Bulk, solid, fine particles ((powders))', value: 'VY' },
  { text: 'WA - Intermediate bulk container', value: 'WA' },
  { text: 'WB - Wickerbottle', value: 'WB' },
  { text: 'WC - Intermediate bulk container, steel', value: 'WC' },
  { text: 'WD - Intermediate bulk container, aluminium', value: 'WD' },
  { text: 'WF - Intermediate bulk container, metal', value: 'WF' },
  { text: 'WG - Intermediate bulk container, steel, pressurised > 10 kpa', value: 'WG' },
  { text: 'WH - Intermediate bulk container, aluminium, pressurised > 10 kpa', value: 'WH' },
  { text: 'WJ - Intermediate bulk container, metal, pressure 10 kpa', value: 'WJ' },
  { text: 'WK - Intermediate bulk container, steel, liquid', value: 'WK' },
  { text: 'WL - Intermediate bulk container, aluminium, liquid', value: 'WL' },
  { text: 'WM - Intermediate bulk container, metal, liquid', value: 'WM' },
  { text: 'WN - Intermediate bulk container, woven plastic, without coat/liner', value: 'WN' },
  { text: 'WP - Intermediate bulk container, woven plastic, coated', value: 'WP' },
  { text: 'WQ - Intermediate bulk container, woven plastic, with liner', value: 'WQ' },
  { text: 'WR - Intermediate bulk container, woven plastic, coated and liner', value: 'WR' },
  { text: 'WS - Intermediate bulk container, plastic film', value: 'WS' },
  { text: 'WT - Intermediate bulk container, textile with out coat/liner', value: 'WT' },
  { text: 'WU - Intermediate bulk container, natural wood, with inner liner', value: 'WU' },
  { text: 'WV - Intermediate bulk container, textile, coated', value: 'WV' },
  { text: 'WW - Intermediate bulk container, textile, with liner', value: 'WW' },
  { text: 'WX - Intermediate bulk container, textile, coated and liner', value: 'WX' },
  { text: 'WY - Intermediate bulk container, plywood, with inner liner', value: 'WY' },
  { text: 'WZ - Intermediate bulk container, reconstituted wood, with inner liner', value: 'WZ' },
  { text: 'XA - Bag, woven plastic, without inner coat/liner', value: 'XA' },
  { text: 'XB - Bag, woven plastic, sift proof', value: 'XB' },
  { text: 'XC - Bag, woven plastic, water resistant', value: 'XC' },
  { text: 'XD - Bag, plastics film', value: 'XD' },
  { text: 'XF - Bag, textile, without inner coat/liner', value: 'XF' },
  { text: 'XG - Bag, textile, sift proof', value: 'XG' },
  { text: 'XH - Bag, textile, water resistant', value: 'XH' },
  { text: 'XJ - Bag, paper, multi-wall', value: 'XJ' },
  { text: 'XK - Bag, paper, multi-wall, water resistant', value: 'XK' },
  { text: 'YA - Composite packaging, plastic receptacle in steel drum', value: 'YA' },
  { text: 'YB - Composite packaging, plastic receptacle in steel crate box', value: 'YB' },
  { text: 'YC - Composite packaging, plastic receptacle in aluminium drum', value: 'YC' },
  { text: 'YD - Composite packaging, plastic receptacle in aluminium crate', value: 'YD' },
  { text: 'YF - Composite packaging, plastic receptacle in wooden box', value: 'YF' },
  { text: 'YG - Composite packaging, plastic receptacle in plywood drum', value: 'YG' },
  { text: 'YH - Composite packaging, plastic receptacle in plywood box', value: 'YH' },
  { text: 'YJ - Composite packaging, plastic receptacle in fibre drum', value: 'YJ' },
  { text: 'YK - Composite packaging, plastic receptacle in fibreboard box', value: 'YK' },
  { text: 'YL - Composite packaging, plastic receptacle in plastic drum', value: 'YL' },
  { text: 'YM - Composite packaging, plastic receptacle in solid plastic box', value: 'YM' },
  { text: 'YN - Composite packaging, glass receptacle in steel drum', value: 'YN' },
  { text: 'YP - Composite packaging, glass receptacle in steel crate box', value: 'YP' },
  { text: 'YQ - Composite packaging, glass receptacle in aluminium drum', value: 'YQ' },
  { text: 'YR - Composite packaging, glass receptacle in aluminium crate', value: 'YR' },
  { text: 'YS - Composite packaging, glass receptacle in wooden box', value: 'YS' },
  { text: 'YT - Composite packaging, glass receptacle in plywood drum', value: 'YT' },
  { text: 'YV - Composite packaging, glass receptacle in wickerwork hamper', value: 'YV' },
  { text: 'YW - Composite packaging, glass receptacle in fibre drum', value: 'YW' },
  { text: 'YX - Composite packaging, glass receptacle in fibreboard box', value: 'YX' },
  { text: 'YY - Composite packaging, glass receptacle in expandable plastic pack', value: 'YY' },
  { text: 'YZ - Composite packaging, glass receptacle in solid plastic pack', value: 'YZ' },
  { text: 'ZA - Intermediate bulk container, paper, multi-wall', value: 'ZA' },
  { text: 'ZB - Bag, large', value: 'ZB' },
  { text: 'ZC - Intermediate bulk container, paper, multi-wall, water resistant', value: 'ZC' },
  { text: 'ZD - Intermediate bulk container, rigid plastic, with structural equipment, solids', value: 'ZD' },
  { text: 'ZF - Intermediate bulk container, rigid plastic, freestanding, solids', value: 'ZF' },
  { text: 'ZG - Intermediate bulk container, rigid plastic, with structural equipment, pressurised', value: 'ZG' },
  { text: 'ZH - Intermediate bulk container, rigid plastic, freestanding, pressurised', value: 'ZH' },
  { text: 'ZJ - Intermediate bulk container, rigid plastic, with structural equipment, liquids', value: 'ZJ' },
  { text: 'ZK - Intermediate bulk container, rigid plastic, freestanding, liquids', value: 'ZK' },
  { text: 'ZL - Intermediate bulk container, composite, rigid plastic, solids', value: 'ZL' },
  { text: 'ZM - Intermediate bulk container, composite, flexible plastic, solids', value: 'ZM' },
  { text: 'ZN - Intermediate bulk container, composite, rigid plastic, pressurised', value: 'ZN' },
  { text: 'ZP - Intermediate bulk container, composite, flexible plastic, pressurised', value: 'ZP' },
  { text: 'ZQ - Intermediate bulk container, composite, rigid plastic, liquids', value: 'ZQ' },
  { text: 'ZR - Intermediate bulk container, composite, flexible plastic, liquids', value: 'ZR' },
  { text: 'ZS - Intermediate bulk container, composite', value: 'ZS' },
  { text: 'ZT - Intermediate bulk container, fibreboard', value: 'ZT' },
  { text: 'ZU - Intermediate bulk container, flexible', value: 'ZU' },
  { text: 'ZV - Intermediate bulk container, metal, other than steel', value: 'ZV' },
  { text: 'ZW - Intermediate bulk container, natural wood', value: 'ZW' },
  { text: 'ZX - Intermediate bulk container, plywood', value: 'ZX' },
  { text: 'ZY - Intermediate bulk container, reconstituted wood', value: 'ZY' },
  { text: 'ZZ - Mutually defined', value: 'ZZ' }
]
